<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    (matSortChange)="sortData($event)"
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
    matSort
  >
    <!--    Name-->
    <ng-container
      matColumnDef="name"
    >
      <th
        *matHeaderCellDef
        class="w-[15rem] min-w-[15rem]"
        mat-header-cell
        mat-sort-header="name"
      >
        <div class="th-cell pl-[12px]">
          <span class="text-center">Name</span>
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
        <span
          (click)="eachRow.status > userStatusMap.inProcess ?
             openUserDetails(eachRow) : {}"
          [class.clickable]="eachRow.status > userStatusMap.inProcess"
        >
            {{ eachRow.name }}
          </span>
      </td>
    </ng-container>
    <ng-container
      matColumnDef="rl_weekly_journal_entry_count"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
        mat-sort-header="rl_weekly_journal_entry_count"
      >
        <div class="th-cell">
          Past week days journaled
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.rl_weekly_journal_entry_count }}
        </div>
      </td>
    </ng-container>
    <!--    Journaled Days-->
    <ng-container
      matColumnDef="pa_weekly_journal_entry_count"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
        mat-sort-header="pa_weekly_journal_entry_count"
      >
        <div class="th-cell">
          Past week days journaled
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.pa_weekly_journal_entry_count }}
        </div>
      </td>
    </ng-container>
    <!--    Journaled Days-->
    <ng-container
      matColumnDef="st_weekly_journal_entry_count"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
        mat-sort-header="st_weekly_journal_entry_count"
      >
        <div class="th-cell">
          Past week days journaled
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.st_weekly_journal_entry_count }}
        </div>
      </td>
    </ng-container>
    <!--    Points-->
    <ng-container
      matColumnDef="rl_eaten_vs_goal"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
      >
        <div class="th-cell pl-[12px]">
          Past week red light foods eaten/goal
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.rl_eaten_vs_goal }}
        </div>
      </td>
    </ng-container>
    <!--    Points-->
    <ng-container
      matColumnDef="pa_done_vs_goal"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
      >
        <div class="th-cell pl-[12px]">
          Past week Physical Activity/goal
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.pa_done_vs_goal }}
        </div>
      </td>
    </ng-container>
    <!--    Points-->
    <ng-container
      matColumnDef="st_used_vs_goal"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
      >
        <div class="th-cell pl-[12px]">
          Past week screen time used/goal
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.st_used_vs_goal }}
        </div>
      </td>
    </ng-container>
    <!--    Total Journaled Days-->
    <ng-container
      matColumnDef="rl_total_days_journaled"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
        mat-sort-header="rl_total_days_journaled"
      >
        <div class="th-cell pl-[12px]">
          Total days journaled
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.rl_total_days_journaled || 0 }}
        </div>
      </td>
    </ng-container>
    <!--    Total Journaled Days-->
    <ng-container
      matColumnDef="pa_total_days_journaled"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
        mat-sort-header="pa_total_days_journaled"
      >
        <div class="th-cell pl-[12px]">
          Total days journaled
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.pa_total_days_journaled || 0 }}
        </div>
      </td>
    </ng-container>
    <!--    Total Journaled Days-->
    <ng-container
      matColumnDef="st_total_days_journaled"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
        mat-sort-header="st_total_days_journaled"
      >
        <div class="th-cell pl-[12px]">
          Total days journaled
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.st_total_days_journaled || 0 }}
        </div>
      </td>
    </ng-container>
    <!--    GOALS SET/ MET-->
    <ng-container
      matColumnDef="rl_goal_met_vs_set"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
      >
        <div class="th-cell pl-[12px]">
          Total no. of red light foods goals met/set
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.rl_goal_met_vs_set }}
        </div>
      </td>
    </ng-container>
    <!--    GOALS SET/ MET-->
    <ng-container
      matColumnDef="pa_goal_met_vs_set"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
      >
        <div class="th-cell pl-[12px]">
          Total no. of physical activity goals met/set
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.pa_goal_met_vs_set }}
        </div>
      </td>
    </ng-container>
    <!--    GOALS SET/ MET-->
    <ng-container
      matColumnDef="st_goal_met_vs_set"
    >
      <th
        *matHeaderCellDef
        class="w-[10rem] min-w-[10rem]"
        mat-header-cell
      >
        <div class="th-cell pl-[12px]">
          Total no. of screen time goals met/set
        </div>
      </th>
      <td *matCellDef="let eachRow"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.st_goal_met_vs_set }}
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource?.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
